import { useState } from 'react';

import { SmallText, SmallText2 } from 'inpock-ui-react';

import * as S from './styled';

interface FooterInfo {
  info: {
    [key: string]: string;
  };
}

function MarketInfoItem({ label, value }: { label: string; value: string }) {
  return (
    <div className="d-flex" style={{ gap: '4px' }}>
      <SmallText2 color="gray600" fontWeight="bold">
        {label}
      </SmallText2>
      <SmallText2 color="gray600">{value}</SmallText2>
    </div>
  );
}

export function MarketFooterV2({ info }: FooterInfo) {
  const [isInfoOpen, setIsInfoOpen] = useState<boolean>(false);

  const onClickTerms = () => {
    window.open('https://terms.inpock.co.kr/commerce/customer-terms', '_blank');
  };

  const onClickPrivacy = () => {
    window.open('https://terms.inpock.co.kr/commerce/customer-privacy', '_blank');
  };

  return (
    <S.MarketFooter>
      <div className="d-flex align-items-center" style={{ gap: '8px', padding: '12px' }}>
        <div onClick={onClickTerms} style={{ cursor: 'pointer' }}>
          <SmallText color="gray800" fontWeight="bold">
            이용약관
          </SmallText>
        </div>
        <S.VerticalLine width="2px" height="12px" />
        <div onClick={onClickPrivacy} style={{ cursor: 'pointer' }}>
          <SmallText color="gray800" fontWeight="bold">
            개인정보처리방침
          </SmallText>
        </div>
      </div>
      <div className="creator-info" onClick={() => setIsInfoOpen(!isInfoOpen)}>
        <SmallText2 color="gray700" fontWeight="bold">
          사업자정보
        </SmallText2>
        <div className={`arrow-icon ${isInfoOpen ? 'up' : 'down'}`} />
      </div>
      {isInfoOpen && (
        <S.InfoWrapper>
          <div className="d-flex flex-column" style={{ gap: '4px' }}>
            <MarketInfoItem label="상호명" value={info.company_name} />
            <MarketInfoItem label="대표자" value={info.ceo_name} />
            <div className="d-flex align-items-center" style={{ gap: '4px' }}>
              <MarketInfoItem label="전화" value={info.cs_phone} />
              <S.VerticalLine />
              <MarketInfoItem label="이메일" value={info.email || info.cs_email} />
            </div>
          </div>
          <div className="d-flex flex-column" style={{ gap: '4px' }}>
            <MarketInfoItem label="사업장소재지" value={info.location} />
            <div className="d-flex align-items-center" style={{ gap: '4px' }}>
              <MarketInfoItem label="사업자등록번호" value={info.business_number} />
              {info.online_sales_number ? (
                <>
                  <S.VerticalLine />
                  <MarketInfoItem label="통신판매업신고" value={info.online_sales_number} />
                </>
              ) : (
                <SmallText2>(간이과세자)</SmallText2>
              )}
            </div>
            <MarketInfoItem label="호스팅제공" value="에이비제트(주)" />
          </div>
        </S.InfoWrapper>
      )}
    </S.MarketFooter>
  );
}
